import React from 'react';
import PropTypes from 'prop-types';
import { getScrollItemAttributeProp } from '../../utils/scroll/scrollElementUtils';
import generateQuestionFormName from '../../utils/generateQuestionFormName';
import isPageBreak from '../../utils/isPageBreak';
import genericQuestionPropType from '../../config/genericQuestionPropType';
import withBlockMargin from '../../domains/styling/hocs/withBlockMargin';

import styles from './TakerBlockBox.scss';

const TakerBlockBox = ({
  e2e,
  children,
  block,
  marginDomStyles,
  block: { type, clientUuid },
}) => (
  <div
    {...getScrollItemAttributeProp(generateQuestionFormName(clientUuid))}
    style={!isPageBreak(block) ? marginDomStyles : null}
    data-e2e={e2e || `taker-block-${type}`}
    data-testid={`SurveysSpa-TakerBlock-${e2e||type}`}
    className={isPageBreak(block) ? styles.pageBreakBlock : styles.block}
  >
    {children}
  </div>
);

TakerBlockBox.propTypes = {
  e2e: PropTypes.string,
  marginDomStyles: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  block: genericQuestionPropType,
};

export default withBlockMargin(TakerBlockBox);
